export const Logo = ({ className = "", invert = false }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
    <div
      className="flex h-8 w-8 items-center justify-center font-heading font-black text-lg"
      style={{ background: invert ? "#fff" : "#002FA7", color: invert ? "#002FA7" : "#fff" }}
    >
      AI
    </div>
    <span className={`font-heading font-bold tracking-tight text-lg ${invert ? "text-white" : "text-foreground"}`}>
      Marka Radar
    </span>
  </div>
);
